module.exports = __webpack_public_path__ + "img/part-4-1.abb53af9.webp";